export { SponsorDirectoryCompanyHit } from './SponsorDirectoryCompanyHit';
